<template>
  <div class="app-mnpout-info-wrapper" ref="wrapper">
    <h4><slot name="txtHeadline">So läuft die Rufnummernmitnahme ab</slot></h4>
    <div class="subline">
      <slot name="txtSubline">
        Hier findest du alle wichtigen Informationen, die du brauchst, um deine Rufnummer zu einem anderen Anbieter mitzunehmen. Easy!
        Die Beauftragung der Rufnummernmitnahme ist über unsere Hotline möglich:
      </slot>
    </div>
    <slot name="txtHotline"></slot>
  </div>
</template>

<script>
export default {
  name: 'MnpOutInfoWrapper'
}
</script>
